/*
 * @Author: your name
 * @Date: 2019-11-21 18:30:51
 * @LastEditTime: 2024-06-05 11:42:45
 * @LastEditors: mqlpcthree mql_pcthree@163.com
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi(商品管理升级卡)/src/api/employee.js
 */

/**
 * 员工管理相关接口
 */
import { get, post, put, deletes } from "@common/http";
import { reject } from "eslint-plugin-promise/rules/lib/promise-statics";

// 获取员工数据没有分页
export const getEmployee = (param) => get(`/employee/list`, param);

// 过滤超出三个月员工
export const getEmployeeData = (param) => get(`/employee/getEmployeeList`, param);

/**
 * 获取数据
 * @param param
 * @returns {*}
 */
export const getEmployeeListData = (param, id) => get(`/employee/${id ? id : ""}`, param);

// 获取数据 不带分页
// export const GetEmployee = param => get("/employee/list", param);
// export const GetEmployee = param => {
//     return new Promise(async (resolve, reject) => {
//         const result = await get("/employee/list-by-sort", param)
//         console.log("员工数据列表", result)
//         // 问题: 员工数据由于后端插件问题可以会出现重复数据问题
//         // 解决: 前端拿到数据后重新过滤
//         let newData = []
//
//         for (let i = 0; i < result.data.length; i++) {
//             let merk = true
//             for (let j = 0; j < newData.length; j++) {
//                 if (result.data[i].id === newData[j].id) {
//                     merk = false
//                     break; // 结束for循环
//                 }
//             }
//
//             if (merk) newData.push(result.data[i])
//         }
//
//         // let obj = {}
//         // newData = result.data.reduce((cur, next) => {
//         //     obj[next.id] ? '' : obj[next.id] = true && cur.
//         // }, [])
//
//         console.log("过滤后的数据", newData)
//
//         // 过滤后的员工数据重新覆盖，后端返回的员工数据
//         result.data = newData
//         resolve(result)
//     })
// }
export const GetEmployee = (param) => get("/employee/list-by-sort", param);
/**
 * 获取员工的提成信息详情,id为员工id
 * @param param
 * @returns {*}
 */
export const getEmployeeBrokerage = (param, id) => get(`/employee/${id}/brokerage`, param);

// 查找店铺
export const findTenantByName = (param) => get(`/tenant/findTenantByName?tenantName=` + param);

// 存储连锁店铺
export const addSubStore = (param) => post(`/tenant/addSubStore`, param);

// 获取存储的连锁店铺表
export const findSubStore = (id) => get(`/tenant/findSubStore?mainTenantId=` + id);

// 删除连锁店铺
export const delSubStore = (id) => deletes(`/tenant/delSubStore?id=` + id);

/**
 * 删除TDbcEmployee信息
 * @param param
 * @returns {*}
 */
export const deleteEmployee = (param, id) => deletes(`/employee/${id ? id : ""}`, param);

/**
 * 添加TDbcEmployee
 * @param param
 * @returns {*}
 */
export const addEmployee = (param) => post("/employee", param);
export const putEmployee = (param) => put("/employee", param);

/**
 * 发送邀请短息
 * @param param
 * @returns {*}
 */
export const sendEmployeeMessage = (param, config) => post(`/employee/send-invite-message`, param, config);

/**
 * 批量修改员工信息
 * @param param
 * @returns {*}
 */
export const putEmployeeBatch = (param) => put(`/employee/batch`, param);

/**
 * 更改员工状态，员工状态(0:正常（恢复接口可用） 1:禁用，2:离职，离职操作可用)
 * @param param
 * @returns {*}
 */
export const employeeStatus = (param, config) => post(`/employee/status`, param, config);

/**
 * 修改收款时间
 * @param param
 * @returns {*}
 */

export const putOrderBatch = (param) => put(`/order/batch`, param);

/**
 * 修改备注
 * @param param
 * @returns {*}
 */

export const putOrder = (param) => put(`/order`, param);

/**
 * 搜索员工信息
 * @param param
 * @returns {*}
 */

export const getSearchInfo = ({ page = 1, limit = 50, query }) => get(`/employee/?page=${page}&limit=${limit}&query=${query}`);

/**
 * 根据订单id获取支付记录
 * @param id
 * @returns {*}
 */
export const getOrderPayInfo = (id) => get(`/order-payment/listByOrderId/${id}`);

/**
 * 修改订单支付类型
 * @param param
 * @returns {*}
 */

export const putOrderPayInfo = (param) => put("/order/update-order-payMethod", param);

export const getAListOfAllEmployees = (param) => get("/employee/getEmployeeList", param);

// 修改班次
export const changeShiftSave = (param) => put("/dict/edit", param);

// 修改状态
export const exampleChangeTheStatusOfTheCDINRecord = (param) => put("/workAttendance/updateIsUnavailable", param);

// 修改打卡记录
export const modifyThecDInRecord = (param) => put("/workAttendance/modifyAttendanceRecords", param);

export const brokerageListDataOne = param => get('statistic/brokerageListDataOne', param);



// WEBPACK FOOTER //
// ./src/api/employee.js